import { FC, memo } from 'react';

import V2PlacesPresenter from './V2PlacesPresenter';

const V2Places: FC = memo(() => (
  <V2PlacesPresenter />
));

export default V2Places;
